import React, { Component } from 'react';
import autoBind from 'react-autobind';

import { FormGroup, FormFeedback, FormText } from 'reactstrap';

import { ensureScheme } from 'utils/url';
import { convertToDataURL } from 'utils/file';

import FileUploadButton from 'ui/common/rebranding/components/Button/FileUploadButton';
import ImageEditor from 'ui/common/rebranding/components/ImageEditor/ImageEditor';

class ImageField extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {};
  }

  handleInputChange(event) {
    const file = event.target && event.target.files && event.target.files[0];
    this.props.input.onChange(file);

    if (file) {
      convertToDataURL(file).then(data => {
        this.setState({ previewSrc: data });
      });
    }
  }

  render() {
    const {
      input,
      label,
      hint,
      // disabled,
      className,
      defaultPreviewSrc,
      previewProps,
      meta: { form, touched, submitting, error },
    } = this.props;
    const { value } = input;

    const inputId = `${form}-${input.name}`;

    let previewSrc =
      this.state.previewSrc ||
      (typeof value === 'string' && value
        ? ensureScheme(value, 'https')
        : defaultPreviewSrc || null);

    const errorText = (touched || submitting) && error;

    return (
      <FormGroup className={className}>
        {previewSrc && (
          <div className="py-2">
            <ImageEditor
              image={previewSrc}
              {...previewProps}
              onChange={this.props.input.onChange}
            />
          </div>
        )}
        <div>
          {hint && <FormText className="d-block pb-2">{hint}</FormText>}
          {/*
            <div className="fileinput-btn-wrapper">
              <Button disabled={disabled} color="primary">
                {label}
              </Button>
              <input
                disabled={disabled}
                accept="image/*"
                type="file"
                onChange={this.handleInputChange}
              />
            </div>
          */}

          <FileUploadButton
            id={inputId}
            onHandleInputChange={e => this.handleInputChange(e)}
            accept="image/*"
          >
            {label}
          </FileUploadButton>

          {errorText && (
            <FormFeedback className="pt-3 d-block text-danger">{errorText}</FormFeedback>
          )}
        </div>
      </FormGroup>
    );
  }
}

export default ImageField;
